import apiClient from '../config/axiosConfig'; 


export const getMedia = (projectId) => {
    return apiClient.get(`/v2/projects/${projectId}/latestmedia`);
};
